import {ConfigurationTemplateDto} from "@hec/api-dtos";
import {DormerRootState} from "../DormerRootState";

export const getConfigurationTemplatesSelector = (state: DormerRootState): ConfigurationTemplateDto[] => {
  return state.configurationTemplates.configurationTemplates;
}
export const getSelectedConfigurationTemplateSelector = (state: DormerRootState): ConfigurationTemplateDto | null => {
  return state.configurationTemplates.selectedConfigurationTemplateDto;
}
